import { getDefaultCSSColor } from '@ardoq/color-helpers';
import { MetamodelType } from '../state/types';

export const getMetamodelTypeColor = ({
  color,
  level,
}: Pick<MetamodelType, 'level' | 'color'>) =>
  color || getDefaultCSSColor(level);
